module.exports = __webpack_public_path__ + "static/media/gmapsinworkout.6e3cf511.jpg";